import React from "react";
import { ShoppingBag, GraduationCap } from "lucide-react";
import Link from "../library/Link";
import Button from "../library/Button";

export default function EmptyCourses({
  message = "Você ainda não tem nenhum curso",
  description,
  linkTo,
  linkText,
  icon: iconVariant = "default",
}) {
  const Icon = iconVariant === "store" ? ShoppingBag : GraduationCap;

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexDirection: "column",
        padding: "80px 20px",
        textAlign: "center",
        width: "100%",
      }}
    >
      <div
        style={{
          width: 64,
          height: 64,
          borderRadius: "50%",
          backgroundColor: "#F1F5F9",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          marginBottom: 16,
        }}
      >
        <Icon size={28} strokeWidth={1.5} color="#94A3B8" />
      </div>
      <p style={{ fontSize: 16, fontWeight: 600, color: "#334155", marginBottom: 4 }}>
        {message}
      </p>
      {description && (
        <p style={{ fontSize: 14, color: "#94A3B8", maxWidth: 360 }}>
          {description}
        </p>
      )}
      {linkTo && (
        <Link
          to={linkTo}
          component={Button}
          primary
          style={{
            marginTop: 24,
            borderRadius: 8,
            padding: "10px 24px",
            fontSize: 14,
            fontWeight: 600,
          }}
        >
          {linkText}
        </Link>
      )}
    </div>
  );
}
